<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="全局配置使用">
      <el-checkbox v-model="form.useGlobal" @change="setGlobalConfig"></el-checkbox>
    </el-form-item>
    <el-form-item label="栏目个数">
      <el-select v-model="columnNum" :disabled="form.useGlobal">
        <el-option v-for="item in 9" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-for="(item, index) in form.columnIds"
      :key="`id${index}`"
      :label="`栏目${index + 1}`"
    >
      <el-select v-model="form.columnIds[index]" @change="selectChange" :disabled="form.useGlobal">
        <el-option
          v-for="column in getColumnFilterData(form.columnIds[index])"
          :key="column.id"
          :label="column.name"
          :value="column.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi, WorkbenchSettingApi } from '@wiz-api/workbench'
import layoutConfig from './LayoutConfig'

const columnApi = new ColumApi()
const workbenchSettingApi = new WorkbenchSettingApi()
export default {
  props: ['configData', 'mode', 'layoutData', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      columnNum: 1,
      form: {
        columnIds: [],
        useGlobal: false,
      },
      columnData: [],
      globalConfig: {
        columnIds: [],
      },
      config: {
        w: 10,
        h: 10,
      },
    }
  },
  computed: {
    columnFilterData() {
      return _.filter(this.columnData, (item) => {
        return !this.form.columnIds.includes(item.id)
      })
    },
  },
  watch: {
    columnNum: {
      immediate: true,
      handler() {
        this.form.columnIds.length = this.columnNum
        this.selectChange()
      },
    },
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.form.columnIds = val.columnIds || []
          this.form.useGlobal = val.useGlobal || false
          this.columnNum = this.form.columnIds.length || 1
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'component', 'type', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(0)
      if (!err) {
        this.columnData = res
      }
    },
    async getSetting() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'navConfig' })
      if (!err && res.config) {
        this.globalConfig = JSON.parse(res.config)
      }
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
    setGlobalConfig() {
      if (this.form.useGlobal) {
        this.form.columnIds = _.cloneDeep(this.globalConfig.columnIds)
        this.columnNum = this.form.columnIds.length || 1
      }
      this.selectChange()
    },
    getColumnFilterData(columnId) {
      const column = _.find(this.columnData, { id: columnId })
      if (column) {
        return _.concat([column], this.columnFilterData)
      }
      return this.columnFilterData
    },
  },
  created() {
    this.getColumnData()
    this.getSetting()
  },
}
</script>

<style></style>
